module.exports = __webpack_public_path__ + "static/6-04daf4f5db206cf5f6972da8d8060077.jpg";